import { DateTime } from 'luxon'
import type { SampleBucket, SortOperation } from '../OperationTypes.ts'
import { NoConfig } from '../OperationTypes.ts'
import type { MetadataFieldDescriptor } from '../MetadataFields.ts'

const createSortOperation = <TConfig, T extends string>(op: SortOperation<T, TConfig>) => {
  return op
}

const sortBuckets = (buckets: SampleBucket[], field: MetadataFieldDescriptor) => {
  if (field.type === 'datetime') {
    return buckets.sort(
      (a, b) =>
        DateTime.fromISO(field.getter(a.samples[0]) as string).diff(DateTime.fromISO(field.getter(b.samples[0]) as string)).milliseconds
    )
  }

  return buckets.sort((a, b) => {
    const fieldA = field.getter(a.samples[0])
    const fieldB = field.getter(b.samples[0])
    if (typeof fieldA === 'number' && typeof fieldB === 'number') {
      return fieldA - fieldB
    }
    // Handle strings
    if (typeof fieldA === 'string' && typeof fieldB === 'string') {
      return fieldA.localeCompare(fieldB)
    } else return typeof a === 'number' ? -1 : 1
  })
}

export const sortAscending = createSortOperation({
  key: 'sort-ascending',
  type: 'sort',
  label: 'Ascending',
  applicableTo: ['enum', 'string', 'datetime'],
  apply: (buckets, field) => {
    return sortBuckets(buckets, field)
  },
  config: NoConfig
})

export const sortDescending = createSortOperation({
  key: 'sort-descending',
  type: 'sort',
  label: 'Descending',
  applicableTo: ['enum', 'string', 'datetime'],
  apply: (buckets, field) => {
    return sortBuckets(buckets, field).reverse()
  },
  config: NoConfig
})
